<template>
    <Structure_TabsRight>
        <template v-slot:header>
            <Video_Header
                :video="video"
            />
        </template>
        <template v-slot:content>
            <Video_Content
                :video="video"
            />
        </template>
        <template v-slot:tabs>
            <div class="volets">
                <div class="volet" v-for="(volet,key) in video.volets.get()" :key="key" :class="video.volets.isActive(key) ? 'active' : ''"
                     @click="video.volets.setActive(key)">
                    <div class="text">{{ $t(volet.label) }}</div>
                </div>
            </div>
            <Video_Data :video="video" v-if="video.volets.isActiveComponent('Video_Data')"/>
            <Video_Settings :video="video" v-if="video.volets.isActiveComponent('Video_Settings')"/>
        </template>
        <template v-slot:footer>
            <Structure_Popup v-if="video.isNew()" class="fixed small">
                <template v-slot:popup-header>
                    <div class="title-h1 p-1">
                        {{$t('New Video')}}
                    </div>
                </template>
                <template v-slot:popup-content>
                    <input-text v-model="video.name" ref="input-create-name" :placeholder="$t('Name:')"/>
                    <input-media :label="$t('Movie')" v-model="video.video" :storieId="video.getStoryId()" required @change="newVideoUpdated = true"/>
                </template>
                <template v-slot:popup-footer>
                    <div class="flex justify-end p-1">
                        <btn link active @click="video.ongletClose()">
                            {{$t('Cancel')}}
                        </btn>
                        <btn icon border @click="valideNew()">
                            <i class="fal fa-plus"></i> {{$t('Create')}}
                        </btn>
                    </div>
                </template>
            </Structure_Popup>
        </template>
    </Structure_TabsRight>
</template>

<script>
import Structure_TabsRight from '@/views/structures/Structure_TabsRight'
import Template from '@/layouts/Template'
import Header_Name from '@/views/header/Header_Name'
import Video_Header from '@/views/video/Video_Header'
import {video} from '@/class/video/video'
import Video_Data from '@/views/video/Video_Data'
import Video_Settings from '@/views/video/Video_Settings'
import Video_Content from '@/views/video/Video_Content'
import onglet, {saveContentOnglet} from '@/class/onglets/onglet'
import tools from '@/class/tools'
import InputText from '@/modules/input/input-text'
import InputMedia from '@/modules/input/input-media'
import Btn from '@/modules/buttons/btn'
import Structure_Popup from '@/views/structures/Structure_Popup'
import nav from '@/class/nav/nav'

export default {
  name: 'Video',
  components: {
    Structure_Popup,
    Btn,
    InputMedia,
    InputText,
    Video_Content,
    Video_Settings,
    Video_Data,
    Video_Header,
    Header_Name,
    Template,
    Structure_TabsRight},
  data () {
    return {
      video:new video(),
      loadingData: false,

      newVideoUpdated:false
    }
  },
  methods:{
    async start () {
      this.video = new video()
      this.video.historyClear()
      this.loadingData = true

      const videoId = this.$route.params.id || ''
      const storyId = this.$route.params.storyId || 0
      console.log('videoId', videoId)

      if (saveContentOnglet.objectExist(this.video.objectType, videoId) && videoId > 0) {

        this.video = saveContentOnglet.objectGet(this.video.objectType, videoId)

        // this.video.ongletAdd();
        nav.add(this.video)

        await this.$nextTick()
        this.loadingData = false
        return
      }

      this.video.setStoryId(parseInt(storyId))

      if (videoId !== '' && videoId !== '0') {
        console.log(`- id : ${  this.$route.params.id}`)
        this.video.setId(videoId)
      } else {
        console.log('- create new')
        this.$refs['input-create-name'].$refs['input'].focus()
        this.$refs['input-create-name'].$refs['input'].select()
      }

      this.video.ongletSet()

      try {
        if (!await this.video.load()) {
          console.log('Erreur de chargement de l\'objet video')
        }

        console.log(this.video)

        this.video.historyAdd()
        // this.video.ongletAdd();
        nav.add(this.video)
        this.loadingData = false

        saveContentOnglet.objectSave(this.video)

      } catch (e) {
        console.log(e)
        this.loadingData = false
      }
    },

    async valideNew () {
      if (this.video.name === '' || this.video.video.id === '' || !this.newVideoUpdated) {
        return
      }

      this.loadingData = true

      if (!await this.video.save()) {
        this.loadingData = false
        return
      }

      await this.$router.push(this.video.getRoute())
      this.loadingData = false

    }
  },
  mounted () {
    this.start()
  }

}
</script>
